module.exports = __webpack_public_path__ + "static/media/no_svg.0debfc02.svg";